import extendWith from 'lodash.assignwith';

// 替代 jquery 的 getScript 方法
export function getScript(source, callback) {
    const scripts = document.querySelectorAll('script');
    // 脚本已存在，不重复加载
    if ([...scripts].some(item => item.src.indexOf(source) > 0)) {
        if (callback) {
            callback();
        }
        return;
    }
    const script = document.createElement('script');
    const prior = document.querySelector('script');
    script.async = true;
    script.onload = function () {
        callback();
    };
    script.src = source;
    prior.parentNode.insertBefore(script, prior);
}

export function loadJSSDK(url) {
    return new Promise(resolve => {
        getScript(url, () => {
            resolve();
        });
    });
}

export function computeZtID(url) {
    const idExecArr = new RegExp('index-id-(.*).html').exec(url);
    return idExecArr ? idExecArr[1] : 0;
}

export function customExtend(obj, srcObj) {
    return extendWith(obj, srcObj, function (objVal, srcVal) {
        return objVal ? objVal : srcVal;
    });
}

// 对于链接是否有协议头做判断和拼接
export function formatURL(url) {
    // eslint-disable-next-line
    if (url && (url.indexOf('http:') === 0 || url.indexOf('https:') === 0)) {
        return url;
    } else {
        return url ? `${window.location.protocol}${url}` : '';
    }
}

export default {};
